import { render } from "./App.vue?vue&type=template&id=5025777d"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5025777d&lang=less"

import exportComponent from "/Users/jonnorth/VueCloud/cloud-market/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__